// GENERATED FILE, DO NOT MANUALLY EDIT
import { html } from '@horizon/base';
import { HznIconBase } from '../../icon/icon-base.js';
import './types.js';
/**
 *
 * @tag hzn-icon-zoom-in
 * @tagname hzn-icon-zoom-in
 * @summary An individual icon for Horizon
 */
export class HznIconZoomIn extends HznIconBase {
    render() {
        return html `<div class="hzn-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5 9C5 6.23858 7.23858 4 10 4C12.7614 4 15 6.23858 15 9C15 11.7614 12.7614 14 10 14C7.23858 14 5 11.7614 5 9ZM10 2C6.13401 2 3 5.13401 3 9C3 12.866 6.13401 16 10 16C11.5091 16 12.9066 15.5225 14.0497 14.7103L20.5581 21.0037L21.9958 19.6134L15.4993 13.3315C16.4392 12.1399 17 10.6354 17 9C17 5.13401 13.866 2 10 2ZM7 10H9V12H11V10H13V8H11V6H9V8H7V10Z" fill="currentColor"></path>
</svg></div>`;
    }
}
//# sourceMappingURL=zoom-in.js.map